import { Component, ElementRef, Inject, Injector } from '@angular/core';
import { NgbActiveModal, NgbModalRef, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Router } from "@angular/router";
import { DataService } from "../../../services/data/data.service";
import { AppComponentBase } from "../../../services/AppComponentBase";
import { IChangePasswordReq, IChangePasswordRs } from '../../../interfaces/service.response';


@Component({
    selector: "modal-userProfile",
    template: require('./userProfile.component.html'),
    styles: [require('./userProfile.component.css')]
})

export class userProfileModal extends AppComponentBase
 {

    constructor(

        injector: Injector,
        protected router: Router,
        public activeModal: NgbActiveModal,
        public dataService: DataService
    ) {
        super(injector);
    }

    public get UserEmail()
    {
        return this.workspace.userName;
    }

    private _showChangePasswordForm: boolean = false;
    public get showChangePasswordForm (): boolean {
        return this._showChangePasswordForm;
    }
    public set showChangePasswordForm ( value: boolean ) {
        this._showChangePasswordForm = value;
    }

    showFormAction()
    {
        this.showChangePasswordForm = !this.showChangePasswordForm;
    }

    public changePasswordAction()
    {
        this.messageError="";
        this.successMessage = false;
        
        let ChangePassword:IChangePasswordReq = {
           OldPassword: this.oldPassword,
           NewPassword: this.newPassword
        }

            this.dataService.sendRequest({
                Cmd: DataService.TYPE_CHANGEPASSWORD,
                Data: ChangePassword
            });

            this.dataService.dataSubscriber.subscribe(response => {
                if(response.Type=="ChangePasswordRs")
                {
                    var leaderBoardResponse: IChangePasswordRs = <IChangePasswordRs>response;

                    if(leaderBoardResponse.Error!="")
                    {
                        this.messageError = leaderBoardResponse.Error;
                    }
                    else
                    {
                        this.oldPassword="";
                        this.newPassword="";
                        this.confirmPassword="";
                        this.showChangePasswordForm = false;
                        this.successMessage = true;
                    }
                }

            })

        
    }

    private _successMessage: boolean = false;
    public get successMessage (): boolean {
        return this._successMessage;
    }
    public set successMessage ( value: boolean ) {
        this._successMessage = value;
    }



    private _messageError: string = "";
    public get messageError (): string {
        return this._messageError;
    }
    public set messageError ( value: string ) {
        this._messageError = value;
    }


    private _oldPassword: string = "";
    public get oldPassword (): string {
        return this._oldPassword;
    }
    public set oldPassword ( value: string ) {
        this._oldPassword = value;
        this.checkPassword();
    }

    private _newPassword: string = "";
    public get newPassword (): string {
        return this._newPassword;
    }
    public set newPassword ( value: string ) {
        this._newPassword = value;
        this.checkPassword();
    }

    private _confirmPassword: string = "";
    public get confirmPassword (): string {
        return this._confirmPassword;
    }
    public set confirmPassword ( value: string ) {

        this._confirmPassword = value;
        this.checkPassword();

    }

    public checkPassword()
    {
        if(this.oldPassword.length>0)
        {
            if(this.newPassword.length>0&&this.confirmPassword.length>0&&this.newPassword==this.confirmPassword)  
            {
                this.disallowChangePasswordAction = false;
            } 
            else
            {
                this.disallowChangePasswordAction = true;
            }
           
        }  
        else
        {
            this.disallowChangePasswordAction = true;
        }
    }










    private _disallowChangePasswordAction: boolean = true;
    public get disallowChangePasswordAction (): boolean {
        return this._disallowChangePasswordAction;
    }
    public set disallowChangePasswordAction ( value: boolean ) {
        this._disallowChangePasswordAction = value;
    }

}

